<panel width="400">
	<h1>{{ 'company.accounting-plans.terminate' | translate }}</h1>
	<section>
		<reason-select [type]="reasonType.Termination" (valueChange)="selectedTerminationReason = $event" />
		<date-input #terminationDateInput [label]="'company.product-plans.termination-date' | translate" [(value)]="newTerminationDate" [required]="true" [maxDate]="maxTerminationDate" />
		@if (requestRenewal) {
			<div>{{ 'company.product-plans.termination-date-close-to-renewal-date' | translate }}</div>
			<custom-input [vertical]="true" inputType="radio" [(value)]="renewPlan" (valueChange)="validateView()">
				<radio-button [value]="false" [label]="'company.product-plans.termination.dont-renew' | translate" />
				<radio-button [value]="true" [label]="'company.product-plans.termination.do-renew' | translate" />
			</custom-input>
		}
		@if (renewPlan === true) {
			<custom-select [label]="'company.product-plans.edit-auto-revewal.next-period' | translate" [selectList]="periodOptions" [(value)]="nextPeriod" [required]="true" />
		}
		@else {
			<tooltip [text]="'company.accounting-plans.enddate-restricted-by-annual-date' | translate:{ date: productPlan?.restrictEndDate }" [disabled]="!productPlan?.restrictEndDate">
				<date-input [label]="'company.accounting-plans.edit-end-date' | translate" [(value)]="newEndDate" (valueChange)="changedEndDate($event)" [required]="true" [minDate]="minEndDate" [filterDates]="getEndDatesFilter()" />
			</tooltip>
		}
	</section>
	@if (askQuestionRemoveAll) {
		<section>
			<div>{{ 'company.accounting-plans.remove-all-unposted-ledger-posts' | translate }}</div>
		</section>
		<section>
			<button [ngClass]="{ 'selected': removeAllUnpostedInvoicePosts }" (click)="removeAll(true)" [ignoreValidation]="true">{{ 'general.true' | translate }}</button>
			<button [ngClass]="{ 'selected': removeAllUnpostedInvoicePosts == false }" (click)="removeAll(false)" [ignoreValidation]="true">{{ 'general.false' | translate }}</button>
		</section>
	}
	<section>
		<button ghost (click)="cancel()" [ignoreValidation]="true">{{ 'general.cancel' | translate }}</button>
		<button confirm (click)="terminateProductPlan()">{{ 'general.save' | translate }}</button>
	</section>
</panel>

@if (productPlan && accountingPlan) {
	<panel width="600">
		<h1>{{ 'ledger-posts.header' | translate }}</h1>
		<ledger-posts #ledgerPosts [productPlans]="[productPlan]" [displayProductName]="false" [accountingPlan]="accountingPlan" [allowChangingTotalValue]="true" />
	</panel>
}
